import styled, { keyframes } from 'styled-components'

const ballAnimation = (props: any) => keyframes`
  0 {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, -15px);
  }
  100% {
    transform: translate(0, 0);
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const BallsWrapper = styled.div`
  display: flex;
  span {
    animation-delay: 0.275s;
  }
  span + span {
    animation-delay: 0.500s;
  }
  span + span + span {
    animation-delay: 0.775s;
  }
`

export const Ball = styled.span`
  display: inline-block;
  ${props => props.theme.ball}

  &:last-of-type{
    margin-right: 0
  }

  animation-name: ${props => ballAnimation(props)};
  animation-duration: 1s;
  animation-iteration-count: infinite;
`

export const Label = styled.div`
  ${props => props.theme.label}
`

export const ModalLoading = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  background-color: rgba(0, 0, 0, 0.64);
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  z-index: 999;
  transition-duration: 0.275s;
  transition-timing-function: cubic-bezier(0.48, 0, 0.48, 1);
  visibility: visible;
  opacity: 1;

`

export const ModalBody = styled.div`
    margin: 0px auto;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 16px 48px;
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    -webkit-box-pack: justify;
    justify-content: space-between;
    width: auto;
    height: auto;
    box-sizing: border-box;
    overflow: hidden;
    background-color: rgb(255, 255, 255);
    padding: 24px;
    transition-duration: 0.275s;
    transition-timing-function: cubic-bezier(0.48, 0, 0.48, 1);

`